import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Formik, Field as Fieldmik } from 'formik';
import { Form as FormUi, Segment, Button, Container } from 'semantic-ui-react';
import * as yup from 'yup';
import moment from 'moment';
import Axios from 'axios';
import cogoToast from 'cogo-toast';
import { customerCompanyName, customerNameVal, customerLogo } from "../utils/constants";

import APP_CONSTANTS from '../../config/constants';
import AddTitleBar from '../titleBar/addTitleBar';
import LoadingPlaceholder from '../placeholder/loadingPlaceholder';

//Inputs
import { DateData } from '../formikInput/date';
import { MyTextArea } from '../formikInput/input';
//Add-Product
import AddProduct from '../salesOrder/addProduct';
import ActivePurchaseOrder from './activePurchaseOrder'

//Dropdowns
import BillingPartyDropdown from '../dropdowns/billingPartyDropdown';
import CustomerBranchDropdown from '../dropdowns/customerBranchDropdown';
import ConsigneeDropdown from '../dropdowns/consigneeDropdown';
import BranchDropdown from '../dropdowns/branchDropdown';
import VendorVehicleDropdown from '../dropdowns/vendorVehicleDropdown';

//Actions 
import { createCustomerInvoice } from '../../redux/actions/customerInvoiceActions';
import { getCustomerSalesOrder, getSalesOrder } from '../../redux/actions/salesOrderActions';
import ConsignorDropdown from '../dropdowns/consignorDropdown';


const AddCustomerInvoice = (props) => {

    const { createCustomerInvoice, getCustomerSalesOrder, customerSalesOrderData, customerSalesOrderLoading, getSalesOrder, getSalesOrderPagination, customerSalesOrderPagination } = props;

    //State
    const [activateManualPO, setActivateManualPO] = useState(false);
    const [customerName, setCustomerName] = useState("");
    const [initialize, setInitialize] = useState(false)
    const [vendorDetails, setVendorDetails] = useState([]);
    const [branchData, setBranchData] = useState([]);
    const [stateData, setStateData] = useState([]);
    const [vendorStateId, setVendorStateId] = useState('');
    const [masterState, setMasterState] = useState('');
    const [customerDetails, setCustomerDetails] = useState({})
    const [searchText, setSearchText] = useState("");

    const handleSearchString = (searchString) => {
        setInitialize(true);
        setSearchText(searchString.toString());
        getSalesOrder(1, searchString, 1, customerName, '', '', true);
    };

    useEffect(() => {
        cogoToast.info("Select Customer Name first!")

        let token = localStorage.getItem('apiToken')
        let userId = localStorage.getItem('userId')
        let customerNo = localStorage.getItem('customerNo')

        Axios.get(`${APP_CONSTANTS.BASE_URL}/masters/stateMaster?customerNumber=${customerNo}&userId=${userId}`, {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': token
            }
        }).then((response => {
            setStateData(response.data.resultSet)
        }))
            .catch(error => console.log(error))
    }, [])


    const getVendorDetails = childData => {
        setVendorDetails(childData);
    }

    const getCustomerDetails = childData => {
        setCustomerDetails(childData);
    }


    const getBranchData = childData => {
        setBranchData(childData)
    };

    const getBranchSelected = childData => {
        const branchDetails = branchData.find(data => data.billingPartyBranchCode === childData);
        const stateDetails = stateData.find(data => data.stateId === branchDetails && branchDetails.billingPartyBranchStateId);
        setVendorStateId(stateDetails && stateDetails.stateId)
    };

    const getMasterBranchSelected = (branchCode, branchData) => {
        const addedMasterBranchObject = branchData.find(data => data.branchCode === branchCode)
        setMasterState(addedMasterBranchObject.stateId)
    }


    //ArrayHelper
    Array.prototype.sum = function (prop) {
        var total = 0
        for (var i = 0, _len = this.length; i < _len; i++) {
            total += this[i][prop]
        }
        return total
    }

    //Existing PO Array

    let activeSOData = [];

    customerSalesOrderData && Object.keys(customerDetails).length > 0 && customerSalesOrderData.map((o, i) => {
        let temp = {}
        temp.checkbox = false
        temp.soId = o.id
        temp.soReferenceNo = o.reference_number
        temp.clientCode = o.client_code
        temp.branchCode = o.branch_code
        temp.vehicleNo = o.vehicle_number
        temp.soQuantity = o.so_quantity
        temp.soAmount = o.so_amount
        temp.soNumber = o.so_number
        temp.expectedDeliveryDate = o.expectedDeliveryDate ? o.expectedDeliveryDate : ''
        temp.sgstAmount = o.sgst_amount
        temp.cgstAmount = o.cgst_amount
        temp.igstAmount = o.igst_amount
        temp.adjustment = o.adjustment
        temp.totalOrderAmt = o.total_order_amt
        temp.remarks = o.remarks
        temp.gstTaxType = o.gst_tax_type
        temp.soDate = o.so_date
        temp.tdsAmount = o.tds_amount
        temp.taxableAmount = o.taxable_amount
        temp.totalDiscount = o.total_discount
        temp.lr_date = o.lr_date
        temp.lr_no = o.lr_no

        activeSOData[i] = temp
    })

    //Formik
    const initialValues = {
        customerName: customerName,
        invoiceNumber: '',
        consigneeName: '',
        consignorName: '',
        branch: '',
        remarks: '',
        customerBranch: '',
        invoiceDate: '',
        expectedPaymentDate: '',
        referenceNo: '',
        activeSoAddedTotal: '',
        manualSoAddedTotal: '',
        vehicleNumber: '',
        soReferenceNo: '',
        productDetails: [{
            productName: '',
            startDate: '',
            endDate: '',
            quantity: 1,
            rate: '',
            discount: '',
            discountType: "1",
            iGstPercent: 0,
            iGst: 0,
            cGstPercent: 0,
            cGst: 0,
            sGstPercent: 0,
            sGst: 0,
            amount: 0,
        }],
        activeSODetails: activeSOData,
        lrNo: '',
        lrDate: '',
        tripMemoNo: '',
        finalAmount: '',
        activeSOSelected: [],
        getSalesOrderPagination: getSalesOrderPagination
    }

    const validateSchema = yup.object().shape({
        customerName: yup.mixed().required('Customer Name is Required'),
        invoiceDate: yup.mixed().required('Invoice Date is Required'),
        branch: yup.mixed().required('Branch is Required'),
        customerBranch: yup.mixed().required('Customer Branch is Required'),
        consigneeName: yup.mixed().optional(""),
        expectedPaymentDate: yup.mixed().required('Expected Payment Date is Required'),
        referenceNo: yup.mixed().optional(''),
        productDetails: yup.array().of(
            yup.object().shape({
                productName: yup.string(),
                quantity: yup.number("Should be a number").min(1, "Should be more than 0"),
                rate: yup.number("Should be a number").min(1, "Should be more than 1")
                // payment: yup.number().positive().when(['checkbox', 'amountDue'], (checkbox, amountDue, schema) => {
                //     return checkbox && checkbox === true ? schema.required("Payment Amount is Required").min(1, "Payment Amount should be more than 0").max(amountDue, "Payment can't exceed Amount Due") : schema
                // })
            })
        )
    })

    const onSubmit = (values, onSubmitProps) => {
        const customerNumber = localStorage.getItem('customerNo');
        const userId = localStorage.getItem('userId');

        let psLineItems = [];
        values.productDetails.map((product, index) => {
            let temp = {}
            temp.product_code = product.productCode
            temp.start_date = product.startDate
            temp.end_date = product.endDate
            temp.product_qty = product.quantity
            temp.product_price = product.rate
            temp.product_amount = product.rate * product.quantity
            temp.total_amount = product.amount
            temp.igst_percentage = product.iGstPercent
            temp.igst_amount = product.iGst
            temp.cgst_percentage = product.cGstPercent
            temp.cgst_amount = product.cGst
            temp.sgst_percentage = product.sGstPercent
            temp.sgst_amount = product.sGst
            temp.tds_id = ''
            temp.tds_amount = ''
            temp.pending_tds_amount = ''
            temp.no_of_days = ''
            temp.discount = product.discount
            temp.final_discount = product.discount
            temp.discount_type = product.discountType
            temp.taxable_amount = product.rate * product.quantity
            psLineItems[index] = temp
        });

        let exLineItems = [];
        values.activeSOSelected.map((product, index) => {
            exLineItems.push(product.soReferenceNo)
        })

        // if(activateManualPO){
        //     exLineItems = [];
        // } else {
        //     manualPoArray = [];
        // }
        let loginDtsValue = {
            customerCompanyName: customerCompanyName,
            customerName: customerNameVal,
            customerLogo: customerLogo,
        };
        const createCustomerInvoiceData = {
            customer_no: customerNumber,
            user_id: userId,
            consignee_code: values.consigneeName,
            consignor_code: values.consignorName,
            client_code: values.customerName,
            client_branch_code: values.customerBranch,
            invoice_amt: values.finalAmount,
            status_id: '',
            invoice_quantity: '',
            complete_payment: '',
            expected_payment_date: moment(values.expectedPaymentDate).format("DD-MM-YYYY"),
            reference_number: values.referenceNo,
            invoice_date: moment(values.invoiceDate).format("DD-MM-YYYY"),
            total_so_amt: values.finalAmount,
            trip_memo_no: values.tripMemoNo,
            lr_no: values.lrNo,
            lr_date: values.lrDate,
            terms_conditions: '',
            vehicle_no: values.vehicleNumber,
            remarks: values.remarks,
            branch_code: values.branch,
            gst_tax_type: 2,
            active_so: activateManualPO ? 2 : 1,
            sgst_amount:
                values.activeSOSelected.map(item => item.sgstAmount).reduce((prev, next) => parseInt(prev) + parseInt(next))
                +
                psLineItems.map(item => item.sgst_amount).reduce((prev, next) => parseInt(prev) + parseInt(next))
            ,
            cgst_amount:
                values.activeSOSelected.map(item => item.cgstAmount).reduce((prev, next) => parseInt(prev) + parseInt(next))
                +
                psLineItems.map(item => item.cgst_amount).reduce((prev, next) => parseInt(prev) + parseInt(next))
            ,
            igst_amount:
                values.activeSOSelected.map(item => item.igstAmount).reduce((prev, next) => parseInt(prev) + parseInt(next))
                +
                psLineItems.map(item => item.igst_amount).reduce((prev, next) => parseInt(prev) + parseInt(next))
            ,
            so_amount: psLineItems.sum("total_amount"),
            so_tds_amount: "",
            so_sgst_amount: psLineItems.sum("sgst_amount"),
            so_cgst_amount: psLineItems.sum("cgst_amount"),
            so_igst_amount: psLineItems.sum("igst_amount"),
            so_total_discount: +psLineItems.sum("discount"),
            so_total_order_amt: psLineItems.sum("total_amount"),
            so_taxable_amount: psLineItems.sum("taxable_amount"),
            so_quantity: psLineItems.length,
            isPartialBill: 0,
            total_order_amt: values.finalAmount,
            pending_amt: values.finalAmount,
            adjustment: 0,
            sales_order_reference_number: values.soReferenceNo,
            tdsAmount: 0,
            taxable_amount:
                values.activeSOSelected.map(item => item.taxableAmount).reduce((prev, next) => parseInt(prev) + parseInt(next))
                +
                psLineItems.map(item => item.taxable_amount).reduce((prev, next) => parseInt(prev) + parseInt(next))
            ,
            total_discount:
                values.activeSOSelected.map(item => item.totalDiscount).reduce((prev, next) => parseInt(prev) + parseInt(next))
                +
                psLineItems.map(item => item.discount).reduce((prev, next) => parseInt(prev) + parseInt(next))
            ,
            ci_so_reference_numbers: exLineItems,
            products: psLineItems,
            loginDts: loginDtsValue,
        };

        createCustomerInvoice(createCustomerInvoiceData).then(() => {
            setTimeout(() => { onSubmitProps.setSubmitting(false) }, 4000)
        });
    };

    return (
        <React.Fragment>
            <AddTitleBar title="New Customer Invoice" LinkName="/customerinvoice" />
            <div className="m-2">
                <Formik
                    enableReinitialize={initialize}
                    initialValues={initialValues}
                    validationSchema={validateSchema}
                    onSubmit={onSubmit}>
                    {({ touched, errors, values, isSubmitting, handleSubmit }) => (
                        <>
                            <Segment>
                                <div className="ui form tiny">
                                    <FormUi.Group >
                                        <FormUi.Field width="3">
                                            <label className="labelName mt-2">Customer Name<span className='mandatory-star'> *</span></label>
                                        </FormUi.Field>
                                        <FormUi.Field width="4">
                                            <Fieldmik component={BillingPartyDropdown}
                                                name="customerName"
                                                placeholder="Customer Name"
                                                getBranchData={getBranchData}
                                                getVendorDetails={getVendorDetails}
                                                getCustomerSalesOrder={getSalesOrder}
                                                setCustomerName={setCustomerName}
                                                getCustomerDetails={getCustomerDetails}
                                                setInitialize={setInitialize}
                                                SOPagination={true}
                                            />
                                            {touched.customerName && errors.customerName ? <strong className="w3-text-red w3-tiny font-weight-bold">{errors.customerName}</strong> : ''}
                                        </FormUi.Field>
                                        <FormUi.Field width="1" />
                                        <FormUi.Field width="3">
                                            <label className="labelName mt-2">Customer Branch<span className='mandatory-star'> *</span></label>
                                        </FormUi.Field>
                                        <FormUi.Field width="4">
                                            <Fieldmik component={CustomerBranchDropdown}
                                                name="customerBranch"
                                                branchData={branchData}
                                                getBranchSelected={getBranchSelected}
                                            />
                                            {touched.customerBranch && errors.customerBranch ? <strong className="w3-text-red w3-tiny font-weight-bold">{errors.customerBranch}</strong> : ''}
                                        </FormUi.Field>

                                    </FormUi.Group>
                                    <FormUi.Group>
                                        <FormUi.Field width="3">
                                            <label className="labelName mt-2">Consignee Name</label>
                                        </FormUi.Field>
                                        <FormUi.Field width="4">
                                            <Fieldmik component={ConsigneeDropdown} name="consigneeName" placeholder="Consignee Name" getVendorPurchaseOrder={getCustomerSalesOrder} />
                                            {touched.consigneeName && errors.consigneeName ? <strong className="w3-text-red w3-tiny font-weight-bold">{errors.consigneeName}</strong> : ''}
                                        </FormUi.Field>
                                        <FormUi.Field width="1" />
                                        <FormUi.Field width="3">
                                            <label className="labelName mt-2">Branch<span className='mandatory-star'> *</span></label>
                                        </FormUi.Field>
                                        <FormUi.Field width="4">
                                            <Fieldmik component={BranchDropdown} name="branch" placeholder="Branch" getMasterBranchSelected={getMasterBranchSelected} />
                                            {touched.branch && errors.branch ? <strong className="w3-text-red w3-tiny font-weight-bold">{errors.branch}</strong> : ''}
                                        </FormUi.Field>
                                    </FormUi.Group>
                                    <FormUi.Group >
                                        <FormUi.Field width="3">
                                            <label className="labelName mt-2">Consignor Name</label>
                                        </FormUi.Field>
                                        <FormUi.Field width="4">
                                            <Fieldmik component={ConsignorDropdown} name="consignorName"
                                                placeholder="Consignor Name"
                                                branchData={branchData} />
                                            {touched.consignorName && errors.consignorName ? <strong className="w3-text-red w3-tiny font-weight-bold">{errors.consignorName}</strong> : ''}
                                        </FormUi.Field>
                                        <FormUi.Field width="1" />
                                        <FormUi.Field width="3">
                                            <label className="labelName mt-2">Invoice Number</label>
                                        </FormUi.Field>
                                        <FormUi.Field width="3">
                                            <Fieldmik name="invoiceNumber" placeholder="Invoice Number" />
                                            {touched.invoiceNumber && errors.invoiceNumber ? <strong className="w3-text-red w3-tiny font-weight-bold">{errors.invoiceNumber}</strong> : ''}
                                        </FormUi.Field>
                                        <FormUi.Field width="2" />


                                    </FormUi.Group>
                                    <FormUi.Group>
                                        <FormUi.Field width="3">
                                            <label className="labelName mt-2">Reference Number</label>
                                        </FormUi.Field>
                                        <FormUi.Field width="3">
                                            <Fieldmik name="referenceNo" placeholder="Reference Number" />
                                            {touched.referenceNo && errors.referenceNo ? <strong className="w3-text-red w3-tiny font-weight-bold">{errors.referenceNo}</strong> : ''}
                                        </FormUi.Field>
                                        <FormUi.Field width="2" />
                                        <FormUi.Field width="3">
                                            <label className="labelName mt-2">Expected Payment Date<span className='mandatory-star'> *</span></label>
                                        </FormUi.Field>
                                        <FormUi.Field width="3">
                                            <DateData
                                                name={`expectedPaymentDate`}
                                                autoComplete="off"
                                                popperClassName="dateTime"
                                                dateFormat="dd-MM-yyyy"
                                                placeholderText="Date"
                                                minDate={new Date(values.expectedPaymentDate)}
                                                timeIntervals={5}
                                                customInput={<FormUi.Input value={values.invoiceDate} autoComplete="off" className="dateWidth" icon="time" iconPosition="left" />}
                                            />
                                            {touched.expectedPaymentDate && errors.expectedPaymentDate ? <strong className="w3-text-red w3-tiny font-weight-bold">{errors.expectedPaymentDate}</strong> : ''}
                                        </FormUi.Field>
                                    </FormUi.Group>
                                    <FormUi.Group>
                                        <FormUi.Field width="3">
                                            <label className="labelName mt-2">Credit Period<span className='mandatory-star'> </span></label>
                                        </FormUi.Field>
                                        <FormUi.Field width="3">
                                            <Fieldmik disabled name="creditPeriod" value={customerDetails?.creditPeriod ? customerDetails.creditPeriod : 0} placeholder="Credit Period" />
                                            {touched.creditPeriod && errors.creditPeriod ? <strong className="w3-text-red w3-tiny font-weight-bold">{errors.creditPeriod}</strong> : ''}
                                        </FormUi.Field>
                                        <FormUi.Field width="2" />

                                        <FormUi.Field width="3">
                                            <label className="labelName mt-2">Invoice Date<span className='mandatory-star'> *</span></label>
                                        </FormUi.Field>

                                        <FormUi.Field width="3">
                                            <DateData
                                                name={`invoiceDate`}
                                                keyCheck={customerDetails.creditPeriod}
                                                keyCheckName={`expectedPaymentDate`}
                                                autoComplete="off"
                                                popperClassName="dateTime"
                                                dateFormat="dd-MM-yyyy"
                                                placeholderText="Date"
                                                selected={values.invoiceDate}
                                                maxDate={moment().toDate()}
                                                timeIntervals={5}
                                                customInput={<FormUi.Input autoComplete="off" className="dateWidth" icon="time" iconPosition="left" />}
                                            />
                                            {touched.invoiceDate && errors.invoiceDate ? <strong className="w3-text-red w3-tiny font-weight-bold">{errors.invoiceDate}</strong> : ''}
                                        </FormUi.Field>
                                        <FormUi.Field width="1" />
                                    </FormUi.Group>
                                    <FormUi.Group>
                                        <FormUi.Field width="3">
                                            <label className="labelName mt-2">Remarks</label>
                                        </FormUi.Field>
                                        <FormUi.Field width="4">
                                            <Fieldmik component={MyTextArea} name="remarks" placeholder="Remarks" />
                                        </FormUi.Field>
                                    </FormUi.Group>
                                </div>
                            </Segment>

                            {
                                customerSalesOrderLoading ?

                                    <React.Fragment>
                                        <LoadingPlaceholder />
                                    </React.Fragment>

                                    :

                                    <Segment>
                                        <div className="ui form tiny">

                                            <Button
                                                type="button"
                                                onClick={() => { setActivateManualPO(false); }}
                                                style={{ borderRadius: "5px 5px 0px 0px" }}
                                                size="small"
                                                toggle
                                                active={!activateManualPO}
                                            >
                                                Active Sales Order
                                            </Button>
                                            <Button
                                                type="button"
                                                onClick={() => { setActivateManualPO(true) }}
                                                style={{ borderRadius: "5px 5px 0px 0px" }}
                                                size="small"
                                                toggle
                                                active={activateManualPO}

                                            >
                                                New Sales Order
                                            </Button>

                                            {/* FieldArray Component */}
                                            {activateManualPO ?

                                                <>

                                                    <Container className="m-2">
                                                        <FormUi.Group >
                                                            <FormUi.Field width="3">
                                                                <label className="labelName mt-2">Vehicle Number</label>
                                                            </FormUi.Field>
                                                            <FormUi.Field width="3">
                                                                <Fieldmik component={VendorVehicleDropdown} name="vehicleNumber" placeholder="Vehicle Number" value={values.vehicleNumber} />
                                                                {touched.vehicleNumber && errors.vehicleNumber ? <strong className="w3-text-red w3-tiny font-weight-bold">{errors.vehicleNumber}</strong> : ''}
                                                            </FormUi.Field>
                                                            <FormUi.Field width="2" />
                                                            <FormUi.Field width="3">
                                                                <label className="labelName mt-2">SO Reference Number</label>
                                                            </FormUi.Field>
                                                            <FormUi.Field width="3">
                                                                <Fieldmik name="soReferenceNo" placeholder="Reference Number" />
                                                                {touched.soReferenceNo && errors.soReferenceNo ? <strong className="w3-text-red w3-tiny font-weight-bold">{errors.soReferenceNo}</strong> : ''}
                                                            </FormUi.Field>
                                                        </FormUi.Group>
                                                        <FormUi.Group >
                                                            <FormUi.Field width="3">
                                                                <label className="labelName mt-2">Trip Memo Number</label>
                                                            </FormUi.Field>
                                                            <FormUi.Field width="3">
                                                                <Fieldmik name="tripMemoNo" placeholder="Enter Trip Memo No." />
                                                                {touched.tripMemoNo && errors.tripMemoNo ? <strong className="w3-text-red w3-tiny font-weight-bold">{errors.tripMemoNo}</strong> : ''}
                                                            </FormUi.Field>
                                                            <FormUi.Field width="2" />
                                                            <FormUi.Field width="3">
                                                                <label className="labelName mt-2">LR Number</label>
                                                            </FormUi.Field>
                                                            <FormUi.Field width="3">
                                                                <Fieldmik name="lrNo" placeholder="LR Number" />
                                                                {touched.lrNo && errors.lrNo ? <strong className="w3-text-red w3-tiny font-weight-bold">{errors.lrNo}</strong> : ''}
                                                            </FormUi.Field>

                                                        </FormUi.Group>
                                                        <FormUi.Group >
                                                            <FormUi.Field width="3">
                                                                <label className="labelName mt-2">LR Date</label>
                                                            </FormUi.Field>
                                                            <FormUi.Field width="3">
                                                                <DateData
                                                                    name={`lrDate`}
                                                                    autoComplete="off"
                                                                    popperClassName="dateTime"
                                                                    dateFormat="dd-MM-yyyy"
                                                                    placeholderText="Date"
                                                                    selected={values.lrDate}
                                                                    timeIntervals={5}
                                                                    customInput={<FormUi.Input autoComplete="off" className="dateWidth" icon="time" iconPosition="left" />}
                                                                />
                                                                {touched.lrDate && errors.lrDate ? <strong className="w3-text-red w3-tiny font-weight-bold">{errors.lrDate}</strong> : ''}
                                                            </FormUi.Field>
                                                            <FormUi.Field width="2" />


                                                        </FormUi.Group>
                                                    </Container>
                                                    <AddProduct billmode={true} masterState={masterState} vendorStateId={vendorStateId} />

                                                </>

                                                :

                                                <ActivePurchaseOrder
                                                    getSalesOrder={getSalesOrder}
                                                    // getCustomerSalesOrder={getCustomerSalesOrder} 
                                                    getSalesOrderPagination={getSalesOrderPagination}
                                                    activeSOData={activeSOData}
                                                    handleSearchStringCall={handleSearchString}
                                                    customerCode={values.customerName}
                                                    customerSalesOrderPagination={customerSalesOrderPagination}
                                                />

                                            }

                                        </div>
                                    </Segment>

                            }
                            <center><Button disabled={isSubmitting} onClick={handleSubmit} size='mini' primary type='submit'>Submit</Button></center>
                        </>
                    )}
                </Formik>
            </div>
        </React.Fragment>
    )
}


const mapStatetoProps = state => ({
    customerSalesOrderData: state.getSalesOrderData.salesOrder.data,
    customerSalesOrderPagination: state.getSalesOrderData.salesOrder.pagination,
    customerSalesOrderLoading: state.getSalesOrderData.isLoading,
    getSalesOrderPagination: state.getSalesOrderData.salesOrder.pagination,
})

export default connect(mapStatetoProps, { createCustomerInvoice, getCustomerSalesOrder, getSalesOrder })(AddCustomerInvoice)


